import { render } from "./CommentList.vue?vue&type=template&id=bd0bcf60&ts=true"
import script from "./CommentList.vue?vue&type=script&lang=ts"
export * from "./CommentList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__